import request from '@/utils/request'
const API = '/api/positions'

export function Position(params = {}, method = 'get', subpath) {
  var url = params.id ? API + '/' + params.id : API
  url = subpath ? url + '/' + subpath : url
  return request({
    url: url,
    method: method,
    params
  })
}
